import { NextPage } from "next";
import React, { ReactElement } from "react";
import { useSelfie } from "~/components/auth/Auth";
import VendorPage from "~/components/vendor/VendorPage";
import safeGetQueryParameter from "~/lib/utils/safeGetQueryParameter";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";

interface IVendorProps {
  slug: string;
  content?: string | null;
  groupSlug: string | null;
  preview: string | null;
  makers: string | null;
  token: string | null;
}

function getTab(content: string | null, groupSlug: string | null) {
  if (content) {
    return content;
  }

  return groupSlug ? "groups" : "products";
}

const Vendor: NextPage<IVendorProps> = ({ slug, groupSlug, content, preview, makers }: IVendorProps): ReactElement => {
  const user = useSelfie();
  const tab = getTab(content || null, groupSlug);

  return (
    <NavbarLayout>
      <VendorPage vendorSlug={slug} tab={tab} preview={preview} makers={makers} groupSlug={groupSlug} user={user} />
    </NavbarLayout>
  );
};

Vendor.getInitialProps = ({ query }) => {
  return {
    slug: safeGetQueryParameter(query, "vendorSlug"),
    content: safeGetQueryParameter(query, "content"),
    groupSlug: safeGetQueryParameter(query, "groupSlug"),
    preview: safeGetQueryParameter(query, "preview"),
    makers: safeGetQueryParameter(query, "makers"),
    token: safeGetQueryParameter(query, "token"),
  };
};

export default Vendor;
